import React from "react";
import writeXlsxFile from "write-excel-file/browser";
import ExportExcelButton from "./ExportExcelButton";

const fileExtension = ".xlsx";

const ExportExcelFromApi = ({
  apiCall,
  fileName,
  cellHeaders,
  keys,
  addSerialNo = false,
}) => {

  const prepareData = (data) => {
    let excelObj = [];

    data.forEach((item, ind) => {
      let row = {};

      if (addSerialNo) {
        row["S.No."] = ind + 1;
      }

      keys.forEach((key, index) => {
        row[cellHeaders[index]] = item[key];
      });

      excelObj.push(row);
    });

    return excelObj;
  };

  const downloadExcel = async () => {
    try {

      if (!apiCall) return;

      const resp = await apiCall(true); // calling parent API with export=true
      if (!resp) return;

      const excelData = prepareData(resp);
      const headers = Object.keys(excelData[0] || {});
      const rows = [
        headers.map((header) => ({ value: header, fontWeight: "bold" })),
        ...excelData.map((item) =>
          headers.map((header) => ({
            value: item[header] == null ? "" : String(item[header]),
          }))
        ),
      ];

      await writeXlsxFile(rows, { sheet: "data" }).toFile(
        fileName + fileExtension
      );

    } catch (error) {
      console.error("Excel export failed:", error);
    }
  };

  return (
    <ExportExcelButton onClick={downloadExcel} />
  );
};

export default ExportExcelFromApi;